(() => {
  const storageKey = 'verdosa-catalog-product-view';
  const desktop = window.matchMedia('(min-width: 750px)');
  const mobileLandscape = window.matchMedia('(orientation: landscape) and (pointer: coarse)');

  const readPreference = () => {
    try {
      return localStorage.getItem(storageKey) === 'compact' ? 'compact' : 'standard';
    } catch (_) {
      return 'standard';
    }
  };

  const savePreference = (value) => {
    try {
      localStorage.setItem(storageKey, value);
    } catch (_) {}
  };

  const icon = (type) => type === 'compact'
    ? '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>'
    : '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="3" width="16" height="18"/><path d="M4 8h16"/></svg>';

  const initialiseCompactSwatches = (results, enabled) => {
    results.querySelectorAll('product-card product-swatches').forEach((swatches) => {
      const items = [...swatches.querySelectorAll('.variant-option__swatch')];
      const sources = items.map((item) => item.querySelector('.swatch')).filter(Boolean);
      let summary = swatches.querySelector('.verdosa-compact-swatch-summary');
      swatches.querySelectorAll('.verdosa-swatch-scroll').forEach((button) => button.remove());
      swatches.classList.remove('verdosa-swatch-strip', 'is-scrollable');
      items.forEach((item) => item.classList.remove('verdosa-extra-swatch'));

      if (!enabled) {
        swatches.classList.remove('verdosa-compact-swatches');
        summary?.remove();
        return;
      }

      swatches.classList.add('verdosa-compact-swatches');
      if (summary && Number(summary.dataset.colourCount) === sources.length) return;
      summary?.remove();
      summary = document.createElement('div');
      summary.className = 'verdosa-compact-swatch-summary';
      summary.dataset.colourCount = String(sources.length);
      summary.setAttribute('aria-label', `${sources.length} available colour ${sources.length === 1 ? 'variant' : 'variants'}`);

      sources.slice(0, 3).forEach((source) => {
        const dot = document.createElement('span');
        dot.className = 'verdosa-compact-swatch-dot';
        dot.setAttribute('aria-hidden', 'true');
        dot.appendChild(source.cloneNode(true));
        summary.appendChild(dot);
      });

      const remaining = Math.max(0, sources.length - 3);
      if (remaining > 0) {
        const more = document.createElement('span');
        more.className = 'verdosa-swatch-more';
        more.textContent = `+${remaining}`;
        more.setAttribute('aria-label', `${remaining} more colour ${remaining === 1 ? 'variant' : 'variants'}`);
        summary.appendChild(more);
      }
      swatches.appendChild(summary);
    });
  };

  const ensureSelectedCatalogueSwatches = (results) => {
    results.querySelectorAll('product-card product-swatches').forEach((swatches) => {
      const inputs = [...swatches.querySelectorAll('.variant-option__swatch input[type="radio"]')];
      if (!inputs.length) return;
      if (!inputs.some((input) => input.checked)) inputs[0].checked = true;
      const sync = () => {
        inputs.forEach((input) => {
          input.closest('.variant-option__swatch')?.classList.toggle('verdosa-is-selected', input.checked);
        });
      };
      if (!swatches.dataset.verdosaSelectionReady) {
        inputs.forEach((input) => {
          input.addEventListener('change', sync);
          input.addEventListener('click', () => window.requestAnimationFrame(sync));
        });
        swatches.dataset.verdosaSelectionReady = 'true';
      }
      sync();
    });
  };

  const initialise = () => {
    const results = document.querySelector('results-list.product-grid-container');
    const form = results?.querySelector('.facets-block-wrapper--horizontal .facets__form');
    const sorting = form?.querySelector('.sorting-filter__horizontal');
    const grid = results?.querySelector('.product-grid');
    if (!results || !grid) return;

    ensureSelectedCatalogueSwatches(results);

    form?.querySelectorAll('.facets__summary').forEach((summary) => {
      summary.style.setProperty('background', '#faf7ef', 'important');
      summary.style.setProperty('background-color', '#faf7ef', 'important');
      summary.style.setProperty('color', '#1d5745', 'important');
      summary.style.setProperty('border-color', '#1d5745', 'important');
    });

    let control = results.querySelector('.verdosa-catalog-view-toggle');
    if (!control) {
      control = document.createElement('div');
      control.className = 'verdosa-catalog-view-toggle';
      control.setAttribute('role', 'group');
      control.setAttribute('aria-label', 'Catalogue product card view');
      control.innerHTML = `
        <button type="button" data-catalog-view="standard" aria-pressed="false">${icon('standard')}<span>Standard</span></button>
        <button type="button" data-catalog-view="compact" aria-pressed="false">${icon('compact')}<span>Compact</span></button>`;
    }

    let mobileRow = results.querySelector('.verdosa-mobile-catalog-view-row');
    if (desktop.matches && form && sorting) {
      if (control.parentNode !== form || control.previousElementSibling !== sorting) sorting.after(control);
      mobileRow?.remove();
    } else {
      if (!mobileRow) {
        mobileRow = document.createElement('div');
        mobileRow.className = 'verdosa-mobile-catalog-view-row';
        grid.parentNode.insertBefore(mobileRow, grid);
      }
      if (!mobileRow.querySelector('.vcat-mobile-count')) { const count=document.createElement('span');count.className='vcat-mobile-count';count.textContent=form?.querySelector('.products-count-wrapper')?.textContent.trim() || '';mobileRow.prepend(count); }
      const counter=mobileRow.querySelector('.vcat-mobile-count'), countText=form?.querySelector('.products-count-wrapper')?.textContent.trim() || '';if(counter && counter.textContent!==countText)counter.textContent=countText;
      if(control.parentNode!==mobileRow)mobileRow.appendChild(control);
    }

    const buttons = [...control.querySelectorAll('button')];
    const apply = (value, persist = false) => {
      const view = value === 'compact' ? 'compact' : 'standard';
      if (desktop.matches) {
        results.dataset.catalogProductView = view;
        if (view === 'compact') {
          grid.style.setProperty('--product-grid-columns-desktop', 'repeat(5, minmax(0, 1fr))', 'important');
          grid.style.setProperty('grid-template-columns', 'repeat(5, minmax(0, 1fr))', 'important');
        } else {
          grid.style.removeProperty('--product-grid-columns-desktop');
          grid.style.removeProperty('grid-template-columns');
        }
      } else {
        results.dataset.catalogProductView = view;
        if (view === 'compact') {
          const columns = mobileLandscape.matches ? 4 : 2;
          grid.style.setProperty('--product-grid-columns-desktop', `repeat(${columns}, minmax(0, 1fr))`, 'important');
          grid.style.setProperty('--product-grid-columns-mobile', `repeat(${columns}, minmax(0, 1fr))`, 'important');
          grid.style.setProperty('grid-template-columns', `repeat(${columns}, minmax(0, 1fr))`, 'important');
        } else {
          grid.style.removeProperty('--product-grid-columns-desktop');
          grid.style.removeProperty('--product-grid-columns-mobile');
          grid.style.removeProperty('grid-template-columns');
        }
      }
      buttons.forEach((button, index) => {
        const selected = button.dataset.catalogView === view;
        button.setAttribute('aria-pressed', String(selected));
        button.classList.toggle('is-selected', selected);
        button.style.setProperty('background-color', selected ? '#1d5745' : '#faf7ef', 'important');
        button.style.setProperty('color', selected ? '#ffffff' : '#1d5745', 'important');
        button.style.setProperty('border', '1px solid #a7b7aa', 'important');
        button.style.setProperty('border-radius', index === 0 ? '8px 0 0 8px' : '0 8px 8px 0', 'important');
        button.style.setProperty('border-inline-start-width', index === 0 ? '1.5px' : '0', 'important');
      });
      initialiseCompactSwatches(results, !desktop.matches && view === 'compact');
      if (persist) savePreference(view);
    };

    buttons.forEach((button) => { button.onclick = () => apply(button.dataset.catalogView, true); });
    apply(readPreference());
  };

  let queued = false;
  const queueInitialise = () => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      initialise();
    });
  };

  const start = () => {
    initialise();
    const main = document.querySelector('main');
    if (main) new MutationObserver(queueInitialise).observe(main, { childList: true, subtree: true });
    desktop.addEventListener?.('change', initialise);
    mobileLandscape.addEventListener?.('change', initialise);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', initialise);
})();
